.eti-editor {
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
  -webkit-user-select: text;
  user-select: text;
}

.eti-editor > .tiptap.ProseMirror {
  box-sizing: border-box;
  cursor: text;
  min-height: 100%;
  width: 100%;
}
